import { Directive, forwardRef, Input } from '@angular/core';
import { FormLayout } from './form-layout';

/**
 * Specifies that the form should use a grid layout. This causes nested FormComponents to automatically apply the
 * appropriate classes to rows, labels and controls.
 */
@Directive({
  selector: 'form[column-classes]',
  providers: [{ provide: FormLayout, useExisting: forwardRef(() => CapFormColumnsDirective) }]
})
export class CapFormColumnsDirective extends FormLayout {
  @Input('column-classes')
  set columnClasses(s: string) {
    const tokens = s.split(/,/);
    this.labelWrapperClasses = tokens[0] + ' bsg-label-wrapper';
    this.controlWrapperClasses = (tokens[1] || tokens[0]) + ' bsg-input-wrapper';
  }

  groupClasses = 'row';
  labelWrapperClasses: string;
  controlWrapperClasses: string;
  labelClasses = 'col-form-label';
}
